import { type PreloadedEntryPoint } from 'react-relay';
import { useRouter } from 'react-resource-router-next';

import { getRouteEntryPointReference } from '../../utils/entry-point-plugin';

export enum LayoutFieldType {
	layout = 'layout',
	pageContent = 'pageContent',
	sideNavigation = 'sideNavigation',
}

type PageLayoutFieldEntrypointReference = PreloadedEntryPoint<any> | null;

/**
 * Returns the entry point reference for the given layout field.
 *
 * @param layoutField - The layout field to get the entry point reference for.
 * @returns The entry point reference for the given layout field. Returns root entry point reference if the layout field is pageContent.
 */
export const usePageLayoutEntryPoint = (
	layoutField: LayoutFieldType,
): PageLayoutFieldEntrypointReference => {
	const [routerState] = useRouter();
	const entryPointReference = getRouteEntryPointReference(routerState.route);

	if (layoutField === LayoutFieldType.pageContent) {
		return entryPointReference;
	}

	return entryPointReference ? entryPointReference.entryPoints[layoutField] : null;
};
